<template>
    <v-app>
        <app-navigation></app-navigation>
        <side-navigation v-if="!isAuthenticated && $vuetify.breakpoint.mdAndUp"></side-navigation>
        <v-content transition="slide-x-transition">
            <router-view></router-view>
        </v-content>
    </v-app>
</template>

<script>
import AppNavigation from '@/components/AppNavigation';
import SideNavigation from '@/components/SideNavigation';
import { mapGetters } from 'vuex';

export default {
    name: 'App',
    data: () => ({}),
    components: {
        AppNavigation,
        SideNavigation
    },
    computed: {
        isAuthenticated() {
            return this.$store.getters.isAuthenticated;
        }
    },
    created() {}
};
</script>


<style>
.main-layout {
    width: 100%;
    height: 100%;
}
</style>
